import './Anticorrosion.css';
import React from "react";
import Anticorrosion0 from '../../assets/Industries/Anticorrosion/Anticorrosion0.png';
import Anticorrosion1 from '../../assets/Industries/Anticorrosion/Anticorrosion1.png';
import Anticorrosion2 from '../../assets/Industries/Anticorrosion/Anticorrosion2.png';
import Anticorrosion3 from '../../assets/Industries/Anticorrosion/Anticorrosion3.png';
import Anticorrosion4 from '../../assets/Industries/Anticorrosion/Anticorrosion4.png';

const images = [
    { src: Anticorrosion1, text: "Taohuayu Yellow River Bridge" },
    { src: Anticorrosion2, text: "Wuhan Parrot Island Bridge" },
    { src: Anticorrosion3, text: "Hong Kong-Zhuhai-Macao Bridge" },
    { src: Anticorrosion4, text: "Hong Kong-Zhuhai-Macao Bridge" },
];

function Anticorrosion() {
    return (
        <div className="arquitectura-container">
            {/* Sección con título, texto e imagen */}
            <div className="arquitectura-header">
                <div className="arquitectura-texto">
                    <h2>Anticorrosión</h2>
                    <div className="underline"></div>
                    <p>
                        Desde el "compromiso inicial para promover el progreso tecnológico de la durabilidad de los puentes", el sellador anticorrosión si-blue se ha aplicado al puente Hong Kong-Zhuhai-Macao, al edificio del Centro de Shanghai y a otros proyectos influyentes a nivel internacional. Ofrecemos no solo productos, sino también una solución de sellado anticorrosión
                    </p>
                </div>
                <div className="arquitectura-imagen">
                    <img src={Anticorrosion0} alt="Arquitectura" />
                </div>
            </div>

            {/* Sección de Imágenes en Grilla (justo debajo) */}
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <img src={item.src} alt={`Arquitectura ${index + 1}`} />
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Anticorrosion;
